import { HomeMenuThemeSizeConfig } from './types';

const large: HomeMenuThemeSizeConfig = {
  BoxMenu: {},
};

export default large;
